<smvd-ui-table [items]="items" [def]="tableDef"></smvd-ui-table>
